import { KeyValueStore } from './KeyValueStore';
import localforage from 'localforage';

export class KeyValueStoreWeb implements KeyValueStore {
    private readonly dbName = 'triplit';
    private readonly tableName = 'kv-store';

    async init(): Promise<void> {
        localforage.config({
            driver: localforage.INDEXEDDB,
            name: this.dbName,
            version: 1.0,
            storeName: this.tableName,
            description: 'Triplit user data',
        });
        window.dumpKVStore = () => {
            console.table(localforage);
        };
        await localforage.ready();
        return Promise.resolve();
    }

    getValue(key: string): Promise<string | null> {
        return localforage.getItem(key);
    }

    async getItems(keys: readonly string[]): Promise<Map<string, string>> {
        const pairs = await Promise.all(
            keys.map((key) => localforage.getItem(key).then((value) => [key, value] as [string, string | null]))
        );
        return new Map(pairs.filter(([_, value]) => value !== null)) as Map<string, string>;
    }

    getAllKeys(): Promise<string[]> {
        return localforage.keys();
    }

    async setValue(key: string, value: string): Promise<void> {
        await localforage.setItem(key, value);
    }

    removeItem(key: string): Promise<void> {
        return localforage.removeItem(key);
    }

    async isHealthy(): Promise<boolean> {
        try {
            // We don't care whether this key exists or not, we just want to check if the store is functional.
            await localforage.getItem('__health_check__');
        } catch (e) {
            console.warn('KeyValueStoreWeb is not healthy:', e);
            return false;
        }
        return true;
    }

    destroy(): Promise<void> {
        return localforage.dropInstance();
    }
}
